import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
// import { SubscriptionModel } from '../models/subscription.model';
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { Endpoints } from "../../shared/config/endpoints";
import { GeneralService } from "../general.service";
import { OrgModel, UserModel } from "./../../store/storeModels/user.model";

@Injectable({
  providedIn: "root",
})
export class CompaniesService {
  private user: UserModel;
  private org: OrgModel;

  constructor(
    private http: HttpClient,
    private endpoints: Endpoints,
    private gs: GeneralService
  ) {
    this.user = this.gs.user;
    this.org = this.gs.org;
  }

  // Handle Errors
  private handleError = (error: any): Observable<any> => {
    let message = "";
    if (error) {
      if (error.error) {
        message = error.error.message;
      } else {
        message = error.message;
      }
    }
    return of(null);
  };

  // Merge Endpoints
  private get createCompaniesUrl() {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      this.endpoints.companies.createGetOneUpdateDeleteCompanies
    );
  }

  private get getAllCompaniesUrl() {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      this.endpoints.companies.createGetOneUpdateDeleteCompanies
    );
  }

  private get getSalespersonTeamsUrl() {
    const userIDs = [];
    userIDs.push(this.user.id)
    return (
      this.endpoints.peopleEndpoint +
      this.endpoints.companies.getAllTeamsByMemberIds +
      "/" +
      userIDs.join(",")
      +
      "/" +
      this.gs.orgID
      +
      "/1"
    );
  }

  private get getSupervisorTeamsUrl() {
    return (
      this.endpoints.signUpEndpoint +
      this.endpoints.companies.getSupervisorTeams +
      "/" +
      this.gs.orgID +
      "/" +
      this.user.email
    );
  }

  private get getCountTeamsSalesPersonUrl() {
    return (
      this.endpoints.signUpEndpoint +
      this.endpoints.companies.countTeamsSalesperson
    );
  }

  private get getOneCompaniesUrl() {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      this.endpoints.companies.createGetOneUpdateDeleteCompanies
    );
  }
  private get getCompaniesByFilterUrl() {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      this.endpoints.companies.filterCompanies
    );
  }
  private get getCompaniesByCustomFilterUrl() {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      this.endpoints.companies.customFilter
    );
  }
  private get updateCompaniesUrl() {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      this.endpoints.companies.createGetOneUpdateDeleteCompanies
    );
  }
  private get deleteCompaniesUrl() {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      this.endpoints.companies.createGetOneUpdateDeleteCompanies
    );
  }

  private get getContactToCompanyUrl() {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      this.endpoints.companies.addContactToCompany
    );
  }

  private get getWildCardCompaniesUrl() {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      this.endpoints.companies.wildCardCompanies
    );
  }

  private deleteContactFromCompanyUrl(companyId, contactId) {
    return (
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      `${this.endpoints.companies.createGetOneUpdateDeleteCompanies}${companyId}/contact/${contactId}`
    )
  }

  // Company Creation

  createCompanies(payload) {
    const body = {
      ...payload,
      createdBy: this.user.id,
      orgName: this.org.name,
      orgId: this.org.id,
    };
    try {
      return this.http
        .post(this.createCompaniesUrl, body)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getAllCompanyFilter(params) {
    try {
      return this.http
        .get(`${this.getAllCompaniesUrl}filter`, { params })
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getAllCompanies() {
    try {
      return this.http
        .get(this.getAllCompaniesUrl)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getSalespersonTeams() {
    try {
      return this.http
        .get(this.getSalespersonTeamsUrl)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getSupervisorTeams() {
    try {
      return this.http
        .get(this.getSupervisorTeamsUrl)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getCompanyWildcard(value) {
    return this.http.get(
      this.endpoints.leadsCompaniesContactClientsEndpoint +
      `/companies/wildcard/${value}`
    );
  }

  getCountries() {
    return this.http.get<any[]>('./assets/countries.json')
  }
  
  updateCountTeamsSalesPerson(status, type, id) {
    try {
      return this.http
        .post(
          `${this.getCountTeamsSalesPersonUrl}/${status}/${type}/${id}/${this.gs.orgID}`,
          ""
        )
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getWildcardCompanies(params) {
    try {
      return this.http
        .get(`${this.getWildCardCompaniesUrl}${params}`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getCompaniesByFilter(query) {
    try {
      return this.http
        .get(`${this.getCompaniesByFilterUrl}?${query}`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getCompaniesByCustomFilter(query) {
    try {
      return this.http
        .get(`${this.getCompaniesByCustomFilterUrl}?${query}`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getOneCompany(id): Observable<any> {
    return this.http.get(`${this.getOneCompaniesUrl}/${id}`);
  }

  updateCompanies(payload): Observable<any> {
    const body = {}
    Object.keys(payload).forEach(field => {
      if (Array.isArray(payload[field]) && field !== 'salesTerritory') {
        body[field] = ''
      } else {
        body[field] = payload[field]
      }
    });
    return this.http.put(this.updateCompaniesUrl, body);
  }

  uploadCompanies(payload) {
    try {
      const url = `${this.endpoints.fourFourSixEndpoint}/clients/imports`;
      return this.http.post(url, payload).pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  addContactToCompany(payload) {
    try {
      return this.http
        .post(`${this.getContactToCompanyUrl}`, payload)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getContactForCompany(id) {
    try {
      return this.http
        .get(`${this.getOneCompaniesUrl}${id}/contacts`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  deleteCompanies(id) {
    try {
      return this.http
        .delete(`${this.deleteCompaniesUrl}/${id}`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  removeContactFromCompany(companyId, contactId) {
    try {
      return this.http
        .delete(`${this.deleteContactFromCompanyUrl(companyId, contactId)}`)
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getCountryAuthKey(){
    try {
      return this.http
        .get("https://www.universal-tutorial.com/api/getaccesstoken", {
          headers: {
            "api-token": "48LWG4cv9rz3MwBp7FVEkLLIWxq4uPCBa1zlOoaLWT7Yt9GUKWXFzpTEgvN5aN3cGxQ",
            "Accept": "application/json",
            "user-email": "babatunde@notchhr.io"
          }
        })
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getNations(token){
    try {
      return this.http
        .get("https://www.universal-tutorial.com/api/countries/", {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Accept": "application/json"
          }
        })
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

  getStates(country, token){
    try {
      return this.http
        .get(`https://www.universal-tutorial.com/api/states/${country}`, {
          headers: {
            "Authorization": `Bearer ${token}`,
            "Accept": "application/json"
          }
        })
        .pipe(catchError(this.handleError));
    } catch (error) {
      alert(error);
    }
  }

}

export const GetCountryAndState = {
  tokenurl: "https://www.universal-tutorial.com/api/getaccesstoken",
  countryUrl: "https://www.universal-tutorial.com/api/countries/",
  stateUrl: "https://www.universal-tutorial.com/api/states",
  apiToken: "48LWG4cv9rz3MwBp7FVEkLLIWxq4uPCBa1zlOoaLWT7Yt9GUKWXFzpTEgvN5aN3cGxQ"
}